import { authFeatureKey } from './auth.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from '..';

export const getAuthFeatureState =
  createFeatureSelector<AuthState>(authFeatureKey);

export const selectIsAuthenticated = createSelector(
  getAuthFeatureState,
  (state: AuthState) => state.loginResponse.isAuthenticated
);

export const selectAuthState = createSelector(
  getAuthFeatureState,
  (state: AuthState) => state
);

export const selectUserInfo = createSelector(
  getAuthFeatureState,
  (state: AuthState) => state.userData
);

export const selectUserSubscriptions = createSelector(
  getAuthFeatureState,
  (state: AuthState) => state.subscriptions
);

export const selectAccessToken = createSelector(
  getAuthFeatureState,
  (state: AuthState) => state.loginResponse.accessToken
);

export const selectIdToken = createSelector(
  getAuthFeatureState,
  (state: AuthState) => state.loginResponse.idToken
);
